const listFormatter = new Intl.ListFormat("en", { style: "long", type: "conjunction" });

/** Formats items as a human-readable enumeration with "and" before the last one, e.g. ["CNA", "LVN", "RN"] → "CNA, LVN, and RN". */
export function formatListWithAnd(items: string[]): string {
  return listFormatter.format(items);
}
